import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-points-ledger-report',
  templateUrl: './points-ledger-report.component.html',
  styleUrls: ['./points-ledger-report.component.scss']
})
export class PointsLedgerReportComponent implements OnInit {
  loading : boolean = false
  date ;
  selectedDate : any = ""
   constructor(
     private apiService : ApiService,
     private apiConfig : ApiConfiguration,
     private exportExcelService : ExportExcelService
   ) { 
     let currentDate = new Date()
     this.date = moment(currentDate).format("YYYY-MM-DD")
     this.selectedDate = this.date
   }
 
   ngOnInit() {
   }
 
   
   getPointsLegerData(){
    this.loading = true
    this.apiService.get(this.apiConfig.pointsLedgerReport + `?report_id=23&date=${this.date}`).subscribe((res : any)=>{
      console.log(res.data.report_data)
      this.downloadExcel(res.data.report_data)
      this.loading = false
    },err=>{
      this.loading = false
    })
  }
 
   downloadExcel(data){
     let sheetName = "sheet1";
     let filename = "Points_Ledger_Report_";
     let excelData = data;
     let excelArray = [
       { header: 'User ID', key: 'user_id'},
       { header: 'Points Eaned Outlet/Osmosys Code', key: 'outletcode'},
       { header: 'CSM Name',key: 'csm_name'},
       { header: 'CSM Mobile Number', key: 'csm_mobile_number'},
       { header: 'Points Earned/Redeemed', key: 'points'},
       { header: 'Processed Date', key: 'processed_date' },
       { header: 'Credited Date', key: 'credited_date'},
       { header: 'Points Mode', key: 'points_mode'},
       { header: 'Transcation Type', key: 'points_method'},
       { header: 'Transaction Description', key: 'description'}
     ]
     this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
   }

  
}
